import React, {useState, useEffect} from 'react'
import styles from './DailyMonitoring.module.css'
import {CreateAppModal} from '../../../../_metronic/partials/modals/daily-monitoring-stepper/CreateAppModal'
import DailyMonitoringDetail from '../../layout-inpatient/tab-components/DailyMonitoringDetail'
import {useAuth} from '../../../modules/auth'

interface DailyMonitoringPageProps {
  claimDetails: any
  currentView?: string
  status?: string
  hasNewNotification?: boolean
  notificationCount?: number
  handleViewNavigation?: (direction: 'prev' | 'next') => void
  setIsChatOpen?: (isOpen: boolean) => void
  handleRequestIGL?: () => void
  handleRequestFGL?: () => void
  documentsUploaded?: boolean
}

const DailyMonitoringPage: React.FC<DailyMonitoringPageProps> = ({
  claimDetails,
  currentView = 'calendar',
  status,
  hasNewNotification,
  notificationCount,
  handleViewNavigation,
  setIsChatOpen,
  handleRequestIGL,
  handleRequestFGL,
  documentsUploaded,
}) => {
  const user = useAuth()
  const {auth} = useAuth()
  const [currentMonth, setCurrentMonth] = useState(new Date())
  const [selectedDate, setSelectedDate] = useState<number | null>(null)
  const [showModal, setShowModal] = useState(false)
  const [viewDetail, setViewDetail] = useState(false)
  const [specialDates, setSpecialDates] = useState<string[]>([])
  const [claimNumber, setClaimNumber] = useState(claimDetails.claimDetails.claimNumber)
  const [monitoringDetails, setMonitoringDetails] = useState(null)
  const [formattedDate, setFormattedDate] = useState('')
  const [isStatus, setIsStatus] = useState(claimDetails.claimDetails.status)
  console.log('Calendar Status:', isStatus)
  // console.log('handleRequestFGL:', handleRequestFGL);

  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

  const getDaysInMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
  }

  const getFirstDayOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay()
  }

  const daysInMonth = Array.from({length: getDaysInMonth(currentMonth)}, (_, i) => i + 1)
  const firstDayIndex = getFirstDayOfMonth(currentMonth)
  const totalCells = firstDayIndex + daysInMonth.length
  const remainingCells = 42 - totalCells

  // Navigate between months
  const handlePrevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1))
    setSelectedDate(null)
  }

  const handleNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1))
    setSelectedDate(null)
  }

  const formatMonthYear = (date: Date) => {
    return date.toLocaleString('default', {month: 'long', year: 'numeric'})
  }

  const handleDateSelect = (day: number, e: React.MouseEvent) => {
    // Prevent triggering the modal if clicking the cell directly or any child elements not meant for the action
    if (
      !(e.target as HTMLElement).classList.contains(styles.addButton) &&
      !(e.target as HTMLElement).classList.contains(styles.viewButton)
    ) {
      return
    }

    const year = currentMonth.getFullYear()
    const month = currentMonth.getMonth() + 1
    const formattedMonth = month < 10 ? `0${month}` : month
    const formattedDay = day < 10 ? `0${day}` : day
    const formattedDate = `${year}-${formattedMonth}-${formattedDay}`
    setFormattedDate(formattedDate)
    setSelectedDate(day)
    setShowModal(true)
  }

  const handleViewDetail = (day: number) => {
    setSelectedDate(day)
    setViewDetail(true)
    const dateStr = `${currentMonth.getFullYear()}-${currentMonth.getMonth() + 1}-${day}`
    const url = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/DailyMonitoring?ClaimNumber=${claimNumber}&Date=${dateStr}`
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    fetch(url, {headers})
      .then((response) => response.json())
      .then((data) => {
        setMonitoringDetails(data)
      })
      .catch((error) => console.error('Failed to fetch monitoring details', error))
  }

  const handleBackToCalendar = () => {
    setViewDetail(false)
    setSelectedDate(null)
  }

  const refreshCalendarData = () => {
    fetch(
      `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/GetListDateClaimMonitoring?claimNumber=${claimNumber}`,
      {
        headers: {
          Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const formattedDates = data.map((date) => {
          const parsedDate = new Date(date)
          return `${parsedDate.getFullYear()}-${parsedDate.getMonth() + 1}-${parsedDate.getDate()}`
        })
        setSpecialDates(formattedDates)
      })
      .catch((error) => console.error('Failed to fetch special dates', error))
  }

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/GetListDateClaimMonitoring?claimNumber=${claimNumber}`,
      {
        headers: {
          Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        const formattedDates = data.map((date) => {
          const parsedDate = new Date(date)
          return `${parsedDate.getFullYear()}-${parsedDate.getMonth() + 1}-${parsedDate.getDate()}`
        })
        setSpecialDates(formattedDates)
      })
      .catch((error) => console.error('Failed to fetch special dates', error))
  }, [])

  const isPastDate = (date: Date) => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    return date < today
  }

  if (viewDetail && selectedDate !== null) {
    return (
      <div className='container-fluid'>
        <button className='btn btn-secondary mb-3' onClick={handleBackToCalendar}>
          <i className='fas fa-arrow-left me-2'></i>
        </button>
        <DailyMonitoringDetail details={monitoringDetails} onBack={handleBackToCalendar} />
      </div>
    )
  }

  return (
    <div className='d-flex flex-column'>
      <div className={styles['calendar-container-settlement']}>
        <div className='card shadow-sm' style={{marginTop: '40px'}}>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <button className='btn btn-icon btn-light-primary' onClick={handlePrevMonth}>
              <i className='fas fa-chevron-left'></i>
            </button>
            <h3 className='card-title text-center'>{formatMonthYear(currentMonth)}</h3>
            <div className='d-flex align-items-center gap-2'>
              <button className='btn btn-icon btn-light-primary' onClick={handleNextMonth}>
                <i className='fas fa-chevron-right'></i>
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className={styles.calendarGrid}>
              {daysOfWeek.map((day) => (
                <div key={day} className={styles.calendarHeader}>
                  {day}
                </div>
              ))}

              {Array.from({length: firstDayIndex}).map((_, i) => (
                <div key={`empty-${i}`} className={styles.calendarCell}></div>
              ))}

              {daysInMonth.map((day) => {
                const currentDate = new Date(
                  currentMonth.getFullYear(),
                  currentMonth.getMonth(),
                  day
                )
                const dateStr = `${currentMonth.getFullYear()}-${
                  currentMonth.getMonth() + 1
                }-${day}`
                const isToday =
                  dateStr ===
                  `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`
                const hasSpecialContent = specialDates.includes(dateStr)
                const isPast = isPastDate(currentDate)
                const isMissedDate = isPast && !hasSpecialContent

                return (
                  <div
                    key={day}
                    className={`${styles.calendarCell} 
                      ${isToday ? styles.today : ''} 
                      ${selectedDate === day ? styles.selected : ''}
                      ${isMissedDate ? styles.missedDate : ''}`}
                  >
                    <div className={styles.calendarDay}>{day}</div>

                    {hasSpecialContent && (
                      <div className='d-flex justify-content-center'>
                        <button
                          className={`btn btn-icon btn-light-primary btn-sm ${styles.viewButton}`}
                          style={{width: '80%'}}
                          onClick={(e) => {
                            e.stopPropagation()
                            handleViewDetail(day)
                          }}
                        >
                          <i className='fas fa-eye me-1'></i> View
                        </button>
                      </div>
                    )}

                    {isToday && <div className={styles.todayLabel}>Today</div>}

                    {isToday && !hasSpecialContent && (
                      <div className='d-flex justify-content-center'>
                        <button
                          className={`btn btn-icon btn-light-primary btn-sm ${styles.addButton}`}
                          style={{width: '80%'}}
                          onClick={(e) => {
                            e.stopPropagation()
                            const year = currentMonth.getFullYear()
                            const month = currentMonth.getMonth() + 1
                            const formattedMonth = month < 10 ? `0${month}` : month
                            const formattedDay = day < 10 ? `0${day}` : day
                            const formattedDate = `${year}-${formattedMonth}-${formattedDay}`
                            setFormattedDate(formattedDate)
                            setSelectedDate(day)
                            setShowModal(true)
                          }}
                        >
                          <i className='fas fa-plus me-1'></i> Add
                        </button>
                      </div>
                    )}
                  </div>
                )
              })}

              {Array.from({length: remainingCells}).map((_, i) => (
                <div key={`remaining-${i}`} className={styles.calendarCell}></div>
              ))}
            </div>
          </div>
        </div>
        {showModal && (
          <CreateAppModal
            show={showModal}
            handleClose={() => setShowModal(false)}
            claimDetails={claimDetails}
            formattedDate={formattedDate}
            onSuccessSubmit={refreshCalendarData}
          />
        )}
      </div>
    </div>
  )
}

export default DailyMonitoringPage
